export const EXPIRES_IN = {
    SHORT: 1000 * 60 * 1,
    MEDIUM: 1000 * 60 * 3,
    LONG: 1000 * 60 * 5,
    VERY_LONG: 1000 * 60 * 10,
};

class InMemoryCache {
    constructor() {
        this.memory = {};
        window.test = this;
    }

    set(key, value, expiresIn) {
        let exin = -1;
        if (typeof expiresIn === 'number') {
            exin = Date.now() + expiresIn;
        }
        this.memory[key] = {
            value,
            exin
        };
        return this;
    }

    get(key) {
        const rawValue = this.memory[key];
        if (!rawValue) return null;
        if (rawValue.exin !== -1 && Date.now() > rawValue.exin) {
            delete this.memory[key];
            return null;
        }
        const value = rawValue.value;
        return value;
    }
}

export default new InMemoryCache();